<template>
  <div>
    <b-table
      ref="employee-group-table"
      responsive
      hover
      :fields="fields"
      :items="items"
      :busy="isBusy"
      table-class="table-head-custom table-vertical-center"
      @row-clicked="showEditForm"
      show-empty
    >
      <!-- begin: t-head -->
      <template v-slot:head(index)="data">
        <span class="text-dark-75">{{ data.label.toUpperCase() }}</span>
      </template>
      <!-- end: t-head -->

      <!-- begin: t-row -->
      <template v-slot:cell(index)="data">
        <span class="font-weight-bolder">{{ data.index + 1 }}</span>
      </template>
      <!-- end: t-row -->

      <!--  begin:: actions    -->
      <template v-slot:cell(actions)="data">
        <div class="d-flex flex-row justify-content-left">
          <!-- begin::: edit-employee button -->
          <button
            class="btn btn-icon btn-light btn-hover-primary mr-3"
            v-on:click="showEditForm(data.item)"
            v-b-tooltip.hover="$t('EMPLOYEE.HOVER.GROUPEDIT')"
          >
            <span class="svg-icon svg-icon-md svg-icon-secondary menu-icon">
              <inline-svg src="/media/svg/icons/Communication/Write.svg" />
            </span>
          </button>
          <!-- end::: edit-employee button -->

          <!-- begin::: show-employee group btn        -->
          <button
            class="btn btn-icon btn-light btn-hover-primary mr-3"
            v-on:click="showEmployeeGroup(data.item)"
            v-b-tooltip.hover="$t('EMPLOYEE.HOVER.GROUPLIST')"
          >
            <span class="svg-icon svg-icon-md svg-icon-secondary menu-icon">
              <inline-svg src="/media/svg/icons/Communication/Group.svg" />
            </span>
          </button>
          <!-- end::: show-employee group btn        -->

          <button
            class="btn btn-icon btn-light btn-hover-danger mr-3"
            v-on:click="deleteEmployeeGroup(data)"
            v-b-tooltip.hover="$t('EMPLOYEE.HOVER.GROUPDELETE')"
          >
            <span class="svg-icon svg-icon-md svg-icon-gray menu-icon">
              <inline-svg src="/media/svg/icons/General/Trash.svg" />
            </span>
          </button>
          <!-- end::: delete-employee button -->
        </div>
      </template>
      <!--  end:: actions    -->

      <template #table-busy>
        <AppLoader></AppLoader>
      </template>

      <template #empty>
        <AppEmptyList text-top="Empty" text-bottom="No group" />
      </template>
    </b-table>

    <div class="d-flex justify-content-end" v-if="items.length">
      <b-pagination
        pills
        size="lg"
        @change="refresh"
        v-model="pagination.current_page"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
      ></b-pagination>
    </div>

    <GroupMembershipModal></GroupMembershipModal>
    <EmployeeGroupModal></EmployeeGroupModal>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import AppLoader from "@/modules/core/components/loaders/AppLoader";
import GroupMembershipModal from "@/modules/company/components/group/membership/GroupMembershipModal";
import EmployeeGroupModal from "@/modules/company/components/group/EmployeeGroupModal";
import AppEmptyList from "@/modules/core/components/empty/AppEmptyList";

export default {
  name: "EmployeeGroupPageTable",
  components: {
    AppEmptyList,
    EmployeeGroupModal,
    GroupMembershipModal,
    AppLoader,
  },
  props: ["reload"],

  data() {
    return {
      fields: [
        { key: "index", label: "#" },
        {
          key: "name",
          label: this.$t("EMPLOYEETABLE.FULLNAME"),
          sortable: true,
        },
        {
          key: "description",
          label: this.$t("DEPARTMENTFORM.DESCRIPTION"),
          sortable: true,
        },
        { key: "actions", label: this.$t("EMPLOYEETABLE.ACTIONS") },
      ],
    };
  },

  mounted() {
    this.fetch();
  },

  methods: {
    /**
     * Fetch
     */
    async fetch() {
      try {
        const response = await this.$store.dispatch("getEmployeeGroup");

        console.log("Received", response);
        return response;
      } catch (error) {
        console.error(error);
      }
    },

    /**
     * Refresh
     * @param page
     */
    refresh(page) {
      this.$store.commit("setEmployeeGroupPage", page);
      this.fetch();
    },

    /**
     * Show employee group.
     *
     * @param item
     */
    showEmployeeGroup(item) {
      console.log(item);
      const group = {
        id: item.id,
        name: item.name,
        description: item.description,
      };
      this.$store.dispatch("specifyGroup", group);
      this.$bvModal.show("group-membership-modal");
    },

    /**
     * Display the edit form to the user.
     *
     * @param item from row
     */
    showEditForm(item) {
      console.log(item);

      const group = {
        id: item.id,
        name: item.name,
        description: item.description,
        disable_late: item.allow_late === false ? "0" : "1",
      };
      this.$store.dispatch("specifyEmpGroupEdit", group);
      this.$bvModal.show("employee-group-edit-modal");
    },

    /**
     * Begin deleting employee group.
     *
     * Uses GROUP ID.
     *
     * @param data
     */
    deleteEmployeeGroup(data) {
      console.log(data);
      const groupName = data.item.name;

      this.$bvModal
        .msgBoxConfirm(groupName + " will be deleted", {
          title: this.$t("ALERT.SURE"),
        })
        .then((isOkay) => {
          if (isOkay) this.attemptDelete(data.item.id, groupName);
        });
    },

    /**
     * Attempts to delete group using GROUP ID
     *
     * @param groupId
     * @param name
     */
    attemptDelete(groupId, name) {
      console.log("Group id is: ", groupId);

      this.$store
        .dispatch("deleteEmployeeGroup", {
          id: groupId,
        })
        .then(() => {
          this.$bvModal.msgBoxOk(`Deleted ${name}!`);
          this.fetch();
        })
        .catch(() => this.$bvModal.msgBoxOk(`Failed to delete ${name}`));
    },
  },

  computed: {
    ...mapState({
      isBusy: (state) =>
        state.CompanyModule.EmployeeGroupStore.EmployeeGroupList.isBusy,
    }),
    ...mapGetters({
      items: "getEmployeeGroup",
      pagination: "getEmployeeGroupPagination",
    }),
  },

  watch: {
    reload() {
      console.log("Reload Table!");
      this.$store.dispatch("getEmployeeGroup");
    },
  },
};
</script>

<style scoped></style>
